function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import { SlardarResources } from "../resources";
import { isVGeo, generateScriptTag } from "./shared";
const _getSlardarPreScriptString = (sdkURL, bid, globalName = "SlardarWeb") => `;(function (w, d, u, b, n, pc, ga, ae, po, s, p, e, t, pp) {pc = 'precollect';ga = 'getAttribute';ae = 'addEventListener';po = 'PerformanceObserver';s = function (m) {p = [].slice.call(arguments);p.push(Date.now(), location.href);(m == pc ? s.p.a : s.q).push(p)};s.q = [];s.p = { a: [] };w[n] = s;e = document.createElement('script');e.src = u + '?bid=' + b + '&globalName=' + n;e.crossOrigin = u.indexOf('sdk-web') > 0 ? 'anonymous' : 'use-credentials';d.getElementsByTagName('head')[0].appendChild(e);if (ae in w) {s.pcErr = function (e) {e = e || w.event;t = e.target || e.srcElement;if (t instanceof Element || t instanceof HTMLElement) {if (t[ga]('integrity')) {w[n](pc, 'sri', t[ga]('href') || t[ga]('src'))} else {w[n](pc, 'st', { tagName: t.tagName, url: t[ga]('href') || t[ga]('src') })}} else {w[n](pc, 'err', e.error)}};s.pcRej = function (e) {e = e || w.event;w[n](pc, 'reject', e.reason || (e.detail && e.detail.reason))};w[ae]('error', s.pcErr, true);w[ae]('unhandledrejection', s.pcRej, true);};if('PerformanceLongTaskTiming' in w) {pp = s.pp = { entries: [] };pp.observer = new PerformanceObserver(function (l) {pp.entries = pp.entries.concat(l.getEntries())});pp.observer.observe({ entryTypes: ['longtask', 'largest-contentful-paint','layout-shift'] })}})(window,document,'${sdkURL}','${bid}','${globalName}')`;
const _getSlardarPreScriptInlineScriptTagStringByVRegion = (vregion, bid, globalName = "SlardarWeb") => generateScriptTag({
  script: _getSlardarPreScriptString(SlardarResources.sdkUrlVRegionMap[vregion], bid, globalName)
});
const _getSlardarPreScriptInlineScriptTagStringByVGeo = (vgeo, bid, globalName = "SlardarWeb") => generateScriptTag({
  script: _getSlardarPreScriptString(SlardarResources.sdkUrlVGeoMap[vgeo], bid, globalName)
});
const getSlardarPreScriptInlineStringTag = (region, bid, globalName = "SlardarWeb") => isVGeo(region) ? _getSlardarPreScriptInlineScriptTagStringByVGeo(region, bid, globalName) : _getSlardarPreScriptInlineScriptTagStringByVRegion(region, bid, globalName);
const _getSlardarCspPreScriptScriptTagStringByVRegion = (vregion) => generateScriptTag({
  src: SlardarResources.cspPreScriptUrlVRegionMap[vregion]
});
const _getSlardarCspPreScriptScriptTagStringByVGeo = (vgeo) => generateScriptTag({
  src: SlardarResources.cspPreScriptUrlVGeoMap[vgeo]
});
const _getSlardarGeckoCspPreScriptScriptTagStringByVRegion = (vregion) => generateScriptTag({
  src: SlardarResources.geckoCspPreScriptUrlVRegionMap[vregion]
});
const _getSlardarGeckoCspPreScriptScriptTagStringByVGeo = (vgeo) => generateScriptTag({
  src: SlardarResources.geckoCspPreScriptUrlVGeoMap[vgeo]
});
const getSlardarCspPreScriptScriptTag = (region, useGeckoResource = false) => {
  if (isVGeo(region)) {
    return useGeckoResource ? _getSlardarGeckoCspPreScriptScriptTagStringByVGeo(region) : _getSlardarCspPreScriptScriptTagStringByVGeo(region);
  } else {
    return useGeckoResource ? _getSlardarGeckoCspPreScriptScriptTagStringByVRegion(region) : _getSlardarCspPreScriptScriptTagStringByVRegion(region);
  }
};
const _getSlardarCspJsonConfigByVRegion = (vregion) => ({
  sdkUrl: SlardarResources.sdkUrlVRegionMap[vregion],
  disableInit: true
});
const _getSlardarCspJsonConfigByVGeo = (vgeo) => ({
  sdkUrl: SlardarResources.sdkUrlVGeoMap[vgeo],
  disableInit: true
});
const _getSlardarCspGeckoJsonConfigByVRegion = (vregion) => ({
  sdkUrl: SlardarResources.geckoSdkUrlVRegionMap[vregion],
  disableInit: true
});
const _getSlardarCspGeckoJsonConfigByVGeo = (vgeo) => ({
  sdkUrl: SlardarResources.geckoSdkUrlVGeoMap[vgeo],
  disableInit: true
});
const getSlardarCspJsonConfigScriptTag = (region, configs, useGeckoResource = false) => {
  const _configs = _object_spread({
    slardarClient: "SlardarWeb"
  }, configs);
  let slardarJsonConfig;
  if (isVGeo(region)) {
    if (useGeckoResource) {
      slardarJsonConfig = _object_spread({}, _getSlardarCspGeckoJsonConfigByVGeo(region), _configs);
    } else {
      slardarJsonConfig = _object_spread({}, _getSlardarCspJsonConfigByVGeo(region), _configs);
    }
  } else {
    if (useGeckoResource) {
      slardarJsonConfig = _object_spread({}, _getSlardarCspGeckoJsonConfigByVRegion(region), _configs);
    } else {
      slardarJsonConfig = _object_spread({}, _getSlardarCspJsonConfigByVRegion(region), _configs);
    }
  }
  return generateScriptTag({
    json: {
      id: "slardar-config",
      data: slardarJsonConfig
    }
  });
};
const _getSlardarInitRegionsConfigByVRegion = (vregion) => ({
  domain: SlardarResources.domainVRegionMap[vregion],
  pluginPathPrefix: SlardarResources.pluginPathPrefixVRegionMap[vregion]
});
const _getSlardarInitRegionsConfigByVGeo = (vgeo) => ({
  domain: SlardarResources.domainVGeoMap[vgeo],
  pluginPathPrefix: SlardarResources.pluginPathPrefixVGeoMap[vgeo]
});
const _getSlardarGeckoInitRegionsConfigByVRegion = (vregion) => ({
  domain: SlardarResources.domainVRegionMap[vregion],
  pluginPathPrefix: SlardarResources.geckoPluginPathPrefixVRegionMap[vregion]
});
const _getSlardarGeckoInitRegionsConfigByVGeo = (vgeo) => ({
  domain: SlardarResources.domainVGeoMap[vgeo],
  pluginPathPrefix: SlardarResources.geckoPluginPathPrefixVGeoMap[vgeo]
});
const getSlardarInitRegionsConfig = (region, useGeckoResource = false) => {
  if (isVGeo(region)) {
    return useGeckoResource ? _getSlardarGeckoInitRegionsConfigByVGeo(region) : _getSlardarInitRegionsConfigByVGeo(region);
  } else {
    return useGeckoResource ? _getSlardarGeckoInitRegionsConfigByVRegion(region) : _getSlardarInitRegionsConfigByVRegion(region);
  }
};
const SlardarUtils = {
  getPreScriptInlineStringTag: getSlardarPreScriptInlineStringTag,
  getCspPreScriptScriptTag: getSlardarCspPreScriptScriptTag,
  getCspJsonConfigScriptTag: getSlardarCspJsonConfigScriptTag,
  getInitRegionsConfig: getSlardarInitRegionsConfig
};
export {
  SlardarUtils,
  getSlardarCspJsonConfigScriptTag,
  getSlardarCspPreScriptScriptTag,
  getSlardarInitRegionsConfig,
  getSlardarPreScriptInlineStringTag
};

//# sourceMappingURL=slardar.js.map